export default __webpack_public_path__ + "static/python-6a5cbc319ab3ddf8ef9226eceef513b1.png";